export default __webpack_public_path__ + "static/media/glen-loading-bg.5285d274.webp";